var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertAttentionRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6323_54184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8887 8.22217C15.8887 12.3652 12.5305 15.7222 8.38867 15.7222C4.24683 15.7222 0.888672 12.3652 0.888672 8.22217C0.888672 4.08153 4.24683 0.722168 8.38867 0.722168C12.5305 0.722168 15.8887 4.08153 15.8887 8.22217ZM8.38867 9.73426C7.62038 9.73426 6.99754 10.3571 6.99754 11.1254C6.99754 11.8937 7.62038 12.5165 8.38867 12.5165C9.15697 12.5165 9.7798 11.8937 9.7798 11.1254C9.7798 10.3571 9.15697 9.73426 8.38867 9.73426ZM7.06792 4.73388L7.29225 8.84678C7.30274 9.03924 7.46188 9.18991 7.65461 9.18991H9.12273C9.31547 9.18991 9.4746 9.03924 9.48509 8.84678L9.70943 4.73388C9.72077 4.526 9.55525 4.3512 9.34707 4.3512H7.43024C7.22206 4.3512 7.05657 4.526 7.06792 4.73388Z",
    fill: "#F04438"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6323_54184"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(0.888672 0.722168)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertAttentionRed);
export default __webpack_public_path__ + "static/media/alert_attention_red.42c4b5046571f293cac07b428a095830.svg";
export { ForwardRef as ReactComponent };